import PropTypes from "prop-types";
import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

const style = {
  actionsWrapper: {
    cursor: "pointer",
    display: "inline-flex",
  },
  infoGridItem: {
    alignItems: "center",
    display: "flex",
    minHeight: "36px",
  },
  infoGridItemLabel: {
    fontWeight: "700",
    marginRight: "7px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  forceNewRowModifier: {
    gridColumnStart: "1",
  },
  forceNewFullRowModifier: {
    gridColumn: "1 / span 2",
    "@media (max-width: 768px)": {
      gridColumn: "unset",
    },
  },
};

function InfoGridItem({ actions, classes, label, modifiers, value }) {
  return (
    <div className={classes.infoGridItem + ' ' + modifiers.map(modifier => classes[modifier]).join(' ')}>
      <span className={classes.infoGridItemLabel}>
        {label}:
      </span>

      {value && (
        <span>
          {value}
        </span>
      )}

      {actions && (
        <span className={classes.actionsWrapper}>
          {actions}
        </span>
      )}
    </div>
  );
}

InfoGridItem.defaultProps = {
  modifiers: [],
};

InfoGridItem.propTypes = {
  actions: PropTypes.node,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  modifiers: PropTypes.array,
  value: PropTypes.node,
};

export default withStyles(style)(InfoGridItem);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Grid/InfoGridItem.jsx